import type { AttributeEditModeConfig } from '@source-components-react/types';
import { MOUNT_NAME_ATTRIBUTE, MOUNT_PROPS_ATTRIBUTE } from './mount-attributes';

/**
 * Both settings the mount offers, in the order the Modify drawer shows them.
 *
 * Order is not cosmetic. The drawer renders these top to bottom and the
 * documentation registry asserts its pages match that sequence.
 */
export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: MOUNT_NAME_ATTRIBUTE,
    heading: 'Component Name',
    subHeading:
      'The name your developer registered in the app. Must match exactly, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: MOUNT_PROPS_ATTRIBUTE,
    heading: 'Props',
    subHeading:
      'Name and value pairs passed to that component. The component decides what each name means, for 3 different device resolutions',
    defaultValues: {},
  },
];
